"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var KeyPair = /** @class */ (function () {
    function KeyPair(privateKey, publicKey) {
        this._private = privateKey;
        this._public = publicKey;
    }
    Object.defineProperty(KeyPair.prototype, "privateKey", {
        get: function () {
            return this._private;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyPair.prototype, "publicKey", {
        get: function () {
            return this._public;
        },
        enumerable: true,
        configurable: true
    });
    return KeyPair;
}());
exports.KeyPair = KeyPair;
var ContentType = /** @class */ (function () {
    function ContentType(appId, category, subCategory, isInappropriate) {
        this._appId = appId;
        this._category = category;
        this._subCategory = subCategory;
        this._isInappropriate = isInappropriate;
    }
    ContentType.prototype.getId = function () {
        return this._appId + "." + this._category + "." + this._subCategory + "." + this
            ._isInappropriate;
    };
    return ContentType;
}());
exports.ContentType = ContentType;
var Status;
(function (Status) {
    Status["Uploaded"] = "Uploaded";
    Status["Partially_uploaded"] = "Partially uploaded";
    Status["Uploading"] = "Uploading";
    Status["Expired"] = "Expired";
})(Status = exports.Status || (exports.Status = {}));
var SubmitObject = /** @class */ (function () {
    function SubmitObject() {
        this.authorId = '';
        this.coAuthors = [];
        this.seeders = [];
        this.fileName = '';
        this.date = '';
        this.price = 0;
        this.size = 0;
        this.URI = '';
        this.hash = '';
        this.keyParts = [];
        this.synopsis = { title: '', description: '', content_type_id: '' };
        this.assetId = null;
        this.publishingFeeAsset = null;
    }
    return SubmitObject;
}());
exports.SubmitObject = SubmitObject;
var ContentExchangeObject = /** @class */ (function () {
    function ContentExchangeObject() {
        this.paid_price_before_exchange = null;
        this.paid_price_after_exchange = null;
    }
    return ContentExchangeObject;
}());
exports.ContentExchangeObject = ContentExchangeObject;
//# sourceMappingURL=content.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/model/content.js
// module id = 90
// module chunks = 0